export default {
  sectionTitle: 'Language',
  teamLanguage: 'Team language',
  teamLanguageDescription:
    'The default language for everyone on {{team}}. Members can choose their own.',
  teamLanguageAdminOnly: 'Only team admins can change the team language.',
  yourLanguage: 'Your language',
  yourLanguageDescription: 'Overrides the team language for you only.',
  yourLanguageNoTeamDescription:
    'The language Macro is shown in for you. Automatic follows your browser.',
  useTeamLanguage: 'Use team language ({{language}})',
  automatic: 'Automatic ({{language}})',
  teamAutomatic: 'Automatic (each person’s browser language)',
  updated: 'Language updated',
  updateFailed: 'Could not update the language',
};
